var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "body-wrapper" }, [
    _c("div", { staticClass: "body-content gray" }, [
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column is-one-quarter" }, [
          !_vm.user || !_vm.user.eventPublished
            ? _c("h1", [
                _vm._v(" Let's "),
                _c("br"),
                _vm._v(" get "),
                _c("br"),
                _vm._v(" started ")
              ])
            : _vm._e(),
          _vm.user && _vm.user.eventPublished
            ? _c("h1", [_vm._v(" Your"), _c("br"), _vm._v(" Profile ")])
            : _vm._e(),
          _c("div", { staticClass: "box is-hidden-mobile" }, [
            _c("div", { staticClass: "block" }, [
              _c("aside", { staticClass: "menu" }, [
                _c("p", { staticClass: "menu-label" }, [
                  _vm._v(" Account Settings ")
                ]),
                _c("ul", { staticClass: "menu-list" }, [
                  _c("li", [
                    _c(
                      "a",
                      {
                        class: { "is-active": _vm.step == 1 },
                        on: {
                          click: function($event) {
                            _vm.step = 1
                          }
                        }
                      },
                      [_vm._v("User Profile")]
                    )
                  ]),
                  _vm.user.performingArtist
                    ? _c("li", [
                        _c(
                          "a",
                          {
                            class: { "is-active": _vm.step == 2 },
                            on: {
                              click: function($event) {
                                _vm.step = 2
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.artistsMenuLabel))]
                        )
                      ])
                    : _vm._e(),
                  _vm.user.venueManager
                    ? _c("li", [
                        _c(
                          "a",
                          {
                            class: { "is-active": _vm.step == 3 },
                            on: {
                              click: function($event) {
                                _vm.step = 3
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.venuesMenuLabel))]
                        )
                      ])
                    : _vm._e(),
                  _vm.user.festivalManager
                    ? _c("li", [
                        _c(
                          "a",
                          {
                            class: { "is-active": _vm.step == 4 },
                            on: {
                              click: function($event) {
                                _vm.step = 4
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.festivalsMenuLabel))]
                        )
                      ])
                    : _vm._e(),
                  _c("li", [
                    _c(
                      "a",
                      {
                        class: { "is-active": _vm.step == 5 },
                        on: {
                          click: function($event) {
                            _vm.step = 5
                          }
                        }
                      },
                      [_vm._v("Payment Information")]
                    )
                  ]),
                  _vm.user.referralCode
                    ? _c("li", [
                        _c(
                          "a",
                          {
                            class: { "is-active": _vm.step == 6 },
                            on: {
                              click: function($event) {
                                _vm.step = 6
                              }
                            }
                          },
                          [_vm._v("Referral Code")]
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ])
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.step == 1,
                expression: "step == 1"
              }
            ],
            staticClass: "column"
          },
          [
            _c("div", { staticClass: "box" }, [
              _c("p", [
                _vm._v(
                  " What name should we use to address you when you're logged into Gobo? (This can be different from the name people will see on your event listings—we'll take care of that later.) "
                )
              ]),
              _c("div", { staticClass: "columns" }, [
                _c("div", { staticClass: "column" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("User Name")
                    ]),
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.user.name,
                            expression: "user.name"
                          }
                        ],
                        staticClass: "input is-primary",
                        attrs: { type: "text", placeholder: "User Name" },
                        domProps: { value: _vm.user.name },
                        on: {
                          change: _vm.saveUser,
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.user, "name", $event.target.value)
                          }
                        }
                      })
                    ]),
                    false
                      ? _c("p", { staticClass: "help is-danger" }, [
                          _vm._v(" Please enter a name. ")
                        ])
                      : _vm._e()
                  ])
                ])
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Roles")]),
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.performingArtist,
                        expression: "user.performingArtist"
                      }
                    ],
                    staticClass: "is-checkradio is-success",
                    class: {
                      "has-background-color": _vm.user.performingArtist
                    },
                    attrs: { type: "checkbox", id: "isPerformingArtist" },
                    domProps: {
                      checked: Array.isArray(_vm.user.performingArtist)
                        ? _vm._i(_vm.user.performingArtist, null) > -1
                        : _vm.user.performingArtist
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.user.performingArtist,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.user,
                                  "performingArtist",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.user,
                                  "performingArtist",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.user, "performingArtist", $$c)
                          }
                        },
                        _vm.saveUser
                      ]
                    }
                  }),
                  _c("label", { attrs: { for: "isPerformingArtist" } }, [
                    _vm._v(" Artist/Performer ")
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.venueManager,
                        expression: "user.venueManager"
                      }
                    ],
                    staticClass: "is-checkradio is-success",
                    class: {
                      "has-background-color": _vm.user.venueManager
                    },
                    attrs: { type: "checkbox", id: "isVenueManager" },
                    domProps: {
                      checked: Array.isArray(_vm.user.venueManager)
                        ? _vm._i(_vm.user.venueManager, null) > -1
                        : _vm.user.venueManager
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.user.venueManager,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.user,
                                  "venueManager",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.user,
                                  "venueManager",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.user, "venueManager", $$c)
                          }
                        },
                        _vm.saveUser
                      ]
                    }
                  }),
                  _c("label", { attrs: { for: "isVenueManager" } }, [
                    _vm._v(" Venue Manager ")
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.festivalManager,
                        expression: "user.festivalManager"
                      }
                    ],
                    staticClass: "is-checkradio is-success",
                    class: {
                      "has-background-color": _vm.user.festivalManager
                    },
                    attrs: { type: "checkbox", id: "isFestivalManager" },
                    domProps: {
                      checked: Array.isArray(_vm.user.festivalManager)
                        ? _vm._i(_vm.user.festivalManager, null) > -1
                        : _vm.user.festivalManager
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.user.festivalManager,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.user,
                                  "festivalManager",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.user,
                                  "festivalManager",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.user, "festivalManager", $$c)
                          }
                        },
                        _vm.saveUser
                      ]
                    }
                  }),
                  _c("label", { attrs: { for: "isFestivalManager" } }, [
                    _vm._v(" Festival Manager ")
                  ])
                ])
              ]),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "button is-primary",
                    staticStyle: { display: "none" },
                    on: { click: _vm.facebook }
                  },
                  [_vm._v(" Facebook Me ")]
                )
              ]),
              _c("div", { staticClass: "columns" }, [
                _c("div", { staticClass: "column" }, [
                  _c(
                    "div",
                    { staticClass: "field" },
                    [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("User Image")
                      ]),
                      !_vm.showImagePicker && !_vm.showImageLoading
                        ? _c("div", { staticClass: "imagefield" }, [
                            _vm.user.avatar
                              ? _c("img", {
                                  attrs: {
                                    src: _vm.user.avatar,
                                    alt: "User Image"
                                  }
                                })
                              : _vm._e(),
                            _c(
                              "button",
                              {
                                staticClass: "button",
                                on: {
                                  click: function($event) {
                                    _vm.showImagePicker = true
                                  }
                                }
                              },
                              [_vm._v(" Change Image ")]
                            )
                          ])
                        : _vm._e(),
                      _vm.showImagePicker
                        ? _c("UploadImage", {
                            attrs: {
                              id: "user-" + _vm.user.uid,
                              outputWidth: 460,
                              outputHeight: 460
                            },
                            on: { imageCropped: _vm.saveImage }
                          })
                        : _vm._e(),
                      _c("div", { staticClass: "buttons" }),
                      _vm.showImageLoading
                        ? _c("div", [
                            _c(
                              "progress",
                              {
                                staticClass: "progress is-primary",
                                attrs: { max: "100" },
                                domProps: { value: _vm.percentComplete }
                              },
                              [_vm._v(_vm._s(_vm.percentComplete))]
                            ),
                            _c("p", [_vm._v("Uploading image...")])
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ])
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.step == 2,
                expression: "step == 2"
              }
            ],
            staticClass: "column"
          },
          [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "box" },
              [
                false
                  ? _c("p", [
                      _vm._v(
                        " By creating an artist profile, you will be the owner of that profile. That means that you will have access to change information in the profile or delete it and create events for it. You can also add collaborator, if you’d like, who will have the same access. "
                      )
                    ])
                  : _vm._e(),
                _c("p", [_vm._v(_vm._s(_vm.artistsHeaderLabel))]),
                _vm._l(_vm.profiles, function(profile, index) {
                  return _c("ActEdit", {
                    key: index,
                    attrs: {
                      profile: profile,
                      editing:
                        _vm.shouldEditArtist || _vm.editingArtist == profile.id,
                      menuactive: _vm.menuArtist == profile.id
                    },
                    on: {
                      showmenu: _vm.activateProfileMenu,
                      profileSet: _vm.saveProfile,
                      deleteArtistProfile: _vm.deleteArtist,
                      edit: _vm.editArtist
                    }
                  })
                }),
                _c("div", { staticClass: "buttons" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      attrs: {
                        disabled:
                          _vm.profiles &&
                          _vm.profiles[0] &&
                          !_vm.profiles[_vm.profiles.length - 1].id
                      },
                      on: {
                        click: function($event) {
                          return _vm.addAct()
                        }
                      }
                    },
                    [_vm._m(1), _c("span", [_vm._v("Add Artist")])]
                  )
                ])
              ],
              2
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.step == 3,
                expression: "step == 3"
              }
            ],
            staticClass: "column"
          },
          [
            _vm._m(2),
            _c(
              "div",
              { staticClass: "box" },
              [
                _vm._l(_vm.venues, function(profile, index) {
                  return _c("Venue", {
                    key: index,
                    attrs: {
                      profile: profile,
                      editing:
                        _vm.shouldEditVenue || _vm.editingVenue == profile.id,
                      editable: true
                    },
                    on: { profileSet: _vm.saveVenue, edit: _vm.editVenue }
                  })
                }),
                _c("div", { staticClass: "buttons" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      attrs: {
                        disabled:
                          _vm.profiles &&
                          _vm.profiles[0] &&
                          !_vm.profiles[_vm.profiles.length - 1].id
                      },
                      on: {
                        click: function($event) {
                          return _vm.addVenue()
                        }
                      }
                    },
                    [_vm._m(3), _c("span", [_vm._v("Add Venue")])]
                  )
                ])
              ],
              2
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.step == 4,
                expression: "step == 4"
              }
            ],
            staticClass: "column"
          },
          [
            _vm._m(4),
            _c(
              "div",
              { staticClass: "box" },
              [
                _vm._l(_vm.festivals, function(festival, index) {
                  return _c("Festival", {
                    key: index,
                    attrs: {
                      festival: festival,
                      editing:
                        _vm.shouldEditFestival ||
                        _vm.editingFestival == festival.id,
                      editable: true
                    },
                    on: {
                      festivalChanged: _vm.saveFestival,
                      edit: _vm.editFestival
                    }
                  })
                }),
                _c("div", { staticClass: "buttons" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      attrs: {
                        disabled:
                          _vm.profiles &&
                          _vm.profiles[0] &&
                          !_vm.profiles[_vm.profiles.length - 1].id
                      },
                      on: {
                        click: function($event) {
                          return _vm.addFestival()
                        }
                      }
                    },
                    [_vm._m(5), _c("span", [_vm._v("Add Festival")])]
                  )
                ])
              ],
              2
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.step == 5,
                expression: "step == 5"
              }
            ],
            staticClass: "column"
          },
          [
            _vm.status == "payment" ||
            _vm.status == "stripeRefresh" ||
            (!_vm.status && _vm.user.stripeStatus != "connected")
              ? _c("div", { staticClass: "box" }, [
                  _vm._m(6),
                  _vm._m(7),
                  _c("br"),
                  _c("p", [
                    _vm._v(
                      " In order to send you payments for purchased tickets, we need to connect to your bank account. By default, we'll send payments to you on a nightly basis (on business days). Gobo collects a flat 5% commission that includes credit card processing fees—that's it. No other surcharges or transaction costs. If you are only ticketing free events, you can skip this step. "
                    )
                  ]),
                  _c("br"),
                  _c("p", [
                    _vm._v(
                      ' We use Stripe as our digital payment processor. If you have an existing Stripe account, we can connect to it. If not, you\'ll need to create one. Click the "Connect" button below to proceed. '
                    )
                  ]),
                  _c("br"),
                  !_vm.user.stripeLink
                    ? _c(
                        "a",
                        {
                          staticClass: "button is-primary",
                          class: { "is-loading": _vm.stripelinkStatus },
                          on: { click: _vm.createStripeLink }
                        },
                        [_vm._v("CONNECT TO STRIPE")]
                      )
                    : _vm._e(),
                  _vm.stripelinkStatus && _vm.stripeProgress < 100
                    ? _c("p", [_vm._v(" Requesting Stripe Link ")])
                    : _vm._e(),
                  _vm.stripelinkStatus && _vm.stripeProgress == 100
                    ? _c("p", [_vm._v(" Stripe Link Created ")])
                    : _vm._e(),
                  _vm.stripelinkStatus
                    ? _c(
                        "progress",
                        {
                          staticClass: "progress is-primary",
                          attrs: { max: "100" },
                          domProps: { value: _vm.stripeProgress }
                        },
                        [_vm._v(_vm._s(_vm.stripeProgress) + "%")]
                      )
                    : _vm._e(),
                  (_vm.stripelinkStatus && _vm.stripeProgress == 100) ||
                  _vm.user.stripeLink
                    ? _c("div", [
                        _c("hr"),
                        _vm._m(8),
                        _c("p", [
                          _vm._v(
                            " We have initiated a connection between Stripe and your Gobo profile. Click the button below to finish connecting or creating your Stripe account and linking it to Gobo. "
                          )
                        ]),
                        _c("br"),
                        _vm.user.stripeLink
                          ? _c(
                              "a",
                              {
                                staticClass: "button is-primary",
                                attrs: { href: _vm.user.stripeLink.url }
                              },
                              [_vm._v("COMPLETE PAYMENT SET UP")]
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm.status && !_vm.user.stripeAccount
              ? _c("div", { staticClass: "box" }, [
                  _c(
                    "progress",
                    {
                      staticClass: "progress is-small is-primary",
                      attrs: { max: "100" }
                    },
                    [_vm._v("15%")]
                  ),
                  _c("p", [_vm._v("Completing Stripe set up...")])
                ])
              : _vm._e(),
            _vm.user.stripeStatus == "connected"
              ? _c("div", { staticClass: "box" }, [_vm._m(9)])
              : _vm._e()
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.step == 6,
                expression: "step == 6"
              }
            ],
            staticClass: "column"
          },
          [
            _c("h4", [_vm._v("Referral Link")]),
            _c("div", { staticClass: "box" }, [
              _c("p", [
                _vm._v(
                  " You can share your referral link with friends to earn credits towards your next event. Your referral link is: "
                )
              ]),
              _c("p", { staticClass: "has-text-centered is-size-3" }, [
                _vm._v(
                  " https://app.gobo.show/referral/" +
                    _vm._s(_vm.user.referralCode) +
                    " "
                )
              ]),
              _c("p", { staticClass: "has-text-centered" }, [
                _vm._v("Share this code with your friends!")
              ]),
              _c("p", [
                _vm._v(
                  " When your friends use your referral code to create an account, they will receive a $10 gift card to an independent coffee shop, bookstore, or record store (we have a list- they choose), and you will receive a $10 gift card as well (same details). "
                )
              ]),
              _c("p", [
                _vm._v(
                  " By participating in the Gobo Referral Program, you agree to the following terms: "
                )
              ]),
              _vm._m(10)
            ])
          ]
        ),
        _c("div", {
          staticClass:
            "column is-2 is-1-desktop is-hidden-tablet-only is-hidden-mobile"
        })
      ])
    ]),
    _c("div", { staticClass: "box stepbar" }, [
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "buttons is-right" }, [
            _vm.step > 1
              ? _c(
                  "button",
                  {
                    staticClass: "button",
                    on: {
                      click: function($event) {
                        return _vm.back()
                      }
                    }
                  },
                  [_vm._v(" Back ")]
                )
              : _vm._e(),
            _vm.step === 1 &&
            (_vm.user.performingArtist ||
              _vm.user.venueManager ||
              _vm.user.festivalManager)
              ? _c(
                  "button",
                  {
                    staticClass: "button is-primary",
                    on: {
                      click: function($event) {
                        return _vm.next()
                      }
                    }
                  },
                  [_vm._v(" Create Artist/Venue/Festival Profile ")]
                )
              : _vm._e(),
            _vm.step === 1
              ? _c(
                  "button",
                  {
                    staticClass: "button is-primary",
                    on: {
                      click: function($event) {
                        return _vm.done()
                      }
                    }
                  },
                  [_vm._v(" Create an event ")]
                )
              : _vm._e(),
            _vm.step > 1 && _vm.step !== 5
              ? _c(
                  "button",
                  {
                    staticClass: "button is-primary",
                    on: {
                      click: function($event) {
                        return _vm.next()
                      }
                    }
                  },
                  [_vm._v(" Next ")]
                )
              : _vm._e(),
            _vm.step === 5
              ? _c(
                  "button",
                  {
                    staticClass: "button is-primary",
                    on: {
                      click: function($event) {
                        return _vm.done()
                      }
                    }
                  },
                  [_vm._v(" Done ")]
                )
              : _vm._e()
          ])
        ]),
        _c("div", {
          staticClass:
            "column is-2 is-1-desktop is-hidden-tablet-only is-hidden-mobile"
        })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column" }, [
        _c("h4", [_vm._v("Add artist profile(s) to our database")])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-plus" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column" }, [
        _c("h4", [_vm._v("Add the venues that you manage.")])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-plus" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column" }, [
        _c("h4", [_vm._v("Add the festivals that you manage.")])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-plus" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", [_c("strong", [_vm._v("Step 1:")])])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Connect a bank account to get paid.")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", [_c("strong", [_vm._v("Step 2:")])])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("i", { staticClass: "fas fa-check" }),
      _vm._v(" Stripe account connected!")
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "terms" }, [
      _c("li", [
        _vm._v(
          " Referral codes may only be used for an artist or venue's first published event. The codes are not intended for existing Gobo users. "
        )
      ]),
      _c("li", [
        _vm._v(
          " Referral codes should only be used for personal and non-commercial purposes. Codes can be shared on social media and with personal connections, but they may not be shared on public distribution sites where you are not the primary content owner. "
        )
      ]),
      _c("li", [
        _vm._v(
          " Referrals must sign up, create and publish an event, and sell at least $50 dollars in tickets to be eligible for the reward. Once a referral completes these requirements, each party will receive an email with instructions on how to claim their reward. "
        )
      ]),
      _c("li", [
        _vm._v(
          " Referrals must be made before the new user signs up, and retroactive rewards will not be granted. Any attempt to abuse or manipulate the program such as including self-referrals, fake events, or fraudulent activity, will result in disqualification from the program. Gobo reserves the right to verify eligibility, adjust terms, or discontinue the program at any time. "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }